module.exports = "<h3 mat-dialog-title>\n  {{title}}\n</h3>\n \n<div mat-dialog-content>\n  <!-- <p>{{message}}</p> -->\n  <div [innerHTML]=\"message\"></div>\n</div>\n \n<div mat-dialog-actions>\n    <button mat-raised-button color=\"primary\" (click)=\"onConfirm()\">Oui</button>\n    <button mat-raised-button color=\"warn\" (click)=\"onDismiss()\">Non</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/codevi/Documents/PROJET/resa-parklife/front/src/app/administration/confirm-dialog/confirm-dialog.component.html
// module id = ../../../../../src/app/administration/confirm-dialog/confirm-dialog.component.html
// module chunks = main